// library
import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

// components
import Dashboard from './component/Dashboard'
import Verification from './component/Verification'
import EditVerify from './component/Verification/EditVerify'
import Datauser from './component/Datauser'

const RouteConfig = (
  <Router>
    <div>
      <Switch>
        <Route exact path="/" component={Dashboard}/>
        <Route path="/verification/" component={Verification}/>
        <Route path="/verification-edit/:userId" component={EditVerify}/>
        <Route path="/datauser" component={Datauser}/>      
      </Switch>
    </div>
  </Router>
);

export default RouteConfig



// WEBPACK FOOTER //
// ./src/app/Router.js